import * as React from 'react';

import { PopupPosition } from 'shared/entities/components/Popup';
import {
  SelectorItem,
  SelectorKey,
  SelectorSize,
  SelectorType
} from 'shared/newEntities/components/Selector';
import { SelectorBaseOption } from 'shared/newComponents/SelectorBase';
import {
  TypographyColor,
  TypographySize,
  TypographyWeight
} from 'shared/newEntities/components/Typography';

type Props = SelectorItem & {
  onClick: (id: SelectorKey) => void;
  className?: string;
  largeOption?: boolean;
  selectorSize?: SelectorSize;
  fontSize?: TypographySize;
  fontWeight?: TypographyWeight;
  fontColor?: TypographyColor;
  smallDescription?: boolean;
  hoverReferencePosition?: PopupPosition;
} & (
    | {
        type: SelectorType.single;
        value: SelectorKey | null;
      }
    | {
        type: SelectorType.multi;
        value: SelectorKey[];
      }
  );

const SelectorOption: React.FC<Props> = (props) => {
  const { id, onClick, extraComponent, ...rest } = props;

  const handleClick = React.useCallback(() => {
    onClick(id);
  }, [onClick, id]);

  const isSelected = React.useMemo((): boolean => {
    if (rest.type === SelectorType.single) {
      if (!rest.value) {
        return false;
      }

      return rest.value === id;
    }

    return rest.value.some((curValue) => curValue === id);
  }, [rest.type, rest.value, id]);

  return (
    <SelectorBaseOption
      selected={isSelected}
      onClick={handleClick}
      selectView={rest.type === SelectorType.multi ? 'checkbox' : 'icon'}
      extraComponent={extraComponent}
      hoverReference={rest.hoverReference}
      hoverReferencePosition={rest.hoverReferencePosition}
      {...rest}
    />
  );
};

export default React.memo(SelectorOption);
